import { useCallback } from 'react'

import FosterService from '@/services/fosterService'
import trpc from '@/utils/trpc'

const useMarkDeceased = (fosterId: string) => {
  const fosterUpdateMutation = trpc.foster.update.useMutation()

  const { refreshFosterList } = FosterService.useFosterList()

  const markDeceased = useCallback(async () => {
    await fosterUpdateMutation.mutateAsync({
      id: fosterId,
      deceasedDate: new Date(),
      medications: [],
      vaccinations: [],
    })

    await refreshFosterList()
  }, [fosterId, fosterUpdateMutation, refreshFosterList])

  return { markDeceased }
}

export default useMarkDeceased
